import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { GbmwRedirectLoader } from '@/components/gbmw-redirect-loader';
import { getWorkOrderByIdQueryOptions } from '@/queries/work-orders';
import { useWorkspaceNavigate } from '@/utils/routes';

// Desktop fallback once WorkOrderGbmwRedirectRoute (upstream, pre-auth) has
// already ruled out a mobile/tablet GBMW bounce for this device.
function WorkOrderRedirectPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useWorkspaceNavigate();

  const { data: workOrder, isError } = useQuery({
    ...getWorkOrderByIdQueryOptions({ workOrderId: id }),
    retry: false,
  });

  useEffect(() => {
    // A deleted/archived WO or a lost-access link can't load — fall back to the
    // register rather than leaving the loader spinning.
    if (workOrder) {
      navigate('/work-orders', { state: { workOrder }, replace: true });
    } else if (isError) {
      navigate('/work-orders', { replace: true });
    }
  }, [workOrder, isError, navigate]);

  return <GbmwRedirectLoader />;
}

export default WorkOrderRedirectPage;
